export class TrainingTabConstants {
    public static readonly ColumnName_CoreCurriculum: string = 'Core Training Requirement for Curriculum';
    public static readonly ColumnName_ElectiveCurriculum: string = 'Elective Training Requirement for Curriculum';
    public static readonly TrainingItemGroups_Label: string = 'Training Item Group(s)';
}
